// Development environment. Used by: ng serve (default)
// Production build uses environment.prod.ts via fileReplacements in angular.json.

export const environment = {
  production: false,
  apiBaseUrl: 'https://dev.api.ftndemo.com/api/',
  apiBaseImageUrl: 'https://dev.api.ftndemo.com/api/media/',
  website_Url: 'https://dev.ftndemo.com/',
};
